<template>
<div class="section">
  <div class="section__header">
    <h2>Страница класса</h2>
    <back></back>

    <div v-if="item">
      <p class="class-title">{{ item.title }}</p>
      <p class="class-text">{{ item.desc }}</p>
      <p class="class-text">{{ item.day }} {{", " + item.time }}</p>
    </div>

    <div class="section__menu header-menu">
      <button type="button" class="header-menu__btn" @click="openPopup('EditClass', item)">
        <i class="fas fa-edit"></i>
        Редактировать
      </button>
      <button type="button" class="header-menu__btn" @click="openPopup('MoveClass', item.id)">
        <i class="fas fa-angle-double-right"></i>
        Перенос
      </button>
      <button 
        type="button" 
        class="header-menu__btn" 
        @click="showMessage = !showMessage"
        :class="{active: showMessage}"
      >
        <i class="far fa-comment-dots"></i>
        Сообщение классу
      </button>
      <button 
        type="button" 
        class="header-menu__btn" 
        @click="openPopup('LessonsInfo', lesson_desc)"
      >
        <i class="fas fa-info-circle"></i>
        Информация
      </button>
    </div>
  </div>

  <div class="section__body" v-if="item"> 
    <div class="class-message" v-show="showMessage">
      <h4>Сообщение классу</h4>
      <ckeditor class="ckeditor" v-model="item.params.current_lesson" :config="editorConfig" type="inline"></ckeditor>
      <button type="button" class="header-menu__btn" @click="saveLesson">
        <i class="far fa-save"></i>
        Сохранить
      </button>
    </div>    
    <div class="student-list"> 
      <p class="form__field add-student">
        <v-select label="name" :options="students" v-model="studentToAdd" @input="addStudent" placeholder="Добавить ученика...">
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.name }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.name }}
            </div>
          </template>
        </v-select>
      </p>
      <div class="reports">
        <StudentsList 
          :class_id="item.id" 
          :students="item.students" 
          @add-feedback="openPopup('Feedback', $event)"
          @remove-student="removeStudent"
        />  
      </div>     
    </div>
    <hr> 
    <HomeworkList class="homework-list" :item="item" />
  </div>

  <Popup :isOpened="popupIsOpened" @close="popupIsOpened = false">
    <template v-slot:content>
      <component 
        :is="popupContent" 
        :data="popupData" 
        :atClass="true"
        :classItem="item"

        @close-popup="popupIsOpened = false" 
        @update-class="updateClass"
        @update-lessons-info="lesson_desc = $event"
        @move-class="moveClass"
      ></component>
    </template>
  </Popup>
</div>
</template>

<script>
import CKEditor from 'ckeditor4-vue';
import StudentsList from './StudentsList'
import HomeworkList from "./HomeworkList.vue";
import EditClass from './EditClass.vue'
import MoveClass from './MoveClass.vue'
import Feedback from './Feedback'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import { popup_mix } from '../../../mixins/popup_mix'
import Input from '../../../other/Input'
import swal from 'sweetalert';
import LessonsInfo from './LessonsInfo.vue'

export default {
  mixins: [popup_mix],
  name: "class",
  inject: ['http'],
  data() {
    return {
      showMessage: false,
      classMessage: '',
      item: '',
      title: '',
      lesson: '',
      link: '',
      zoom_desc: '',
      studentToAdd: '',
      lesson_desc: {
        zoom_link: '',
        video_link: '',
        zoom_ident: '',
        desc: ''
      },
      editorConfig: { height: 400 }
    }
  },
  components: {
    ckeditor: CKEditor.component,
    vSelect,
    StudentsList,
    HomeworkList,
    EditClass,
    Feedback,
    Input,
    MoveClass,
    LessonsInfo
  },
  computed: {
    ...mapGetters({
      teacherHomework: 'teacher/homework',
      students: 'teacher/students'
    })
  },
  methods: {
    ...mapActions({
      getHomework: 'teacher/getHomework',
      getTemplates: 'teacher/getTemplates'
    }),
    ...mapMutations({
      removeClass: 'teacher/removeClass'
    }),
    moveClass() {
      this.removeClass(this.item.id)
      swal('Успешно!', 'Класс перенесён', 'success')

      setTimeout(() => this.$router.push('/classes'), 500)
    },
    removeStudent(data) {
      swal({
        title: 'Внимание!',
        text: `Действительно желаете удалить ученика ${data.student.name}?`,
        icon: "warning",
        buttons: ['Отмена', 'Да'],
        dangerMode: true,
      })
      .then((choise) => {
        if (choise) {
          console.log('onDeleteStudentFromClass', { id: data.student.id })
          this.http.post('onDeleteStudentFromClass', { id: data.student.id }).then(() => {
            this.item.students.splice(data.index, 1)
            swal('Успешно!', 'Ученик удалён', 'success')
          }) 
          .catch(e => swal('Что-то пошло не так', '' + e, 'error'))
        } 
      })           
    },
    saveLesson() {
      let data = {
        id: this.item.id, 
        lesson: this.item.params.current_lesson
      }
      console.log(data)
      this.http.post('onSaveLesson', data).then(() => {
        swal('Успешно!', 'Сообщение классу сохранено', 'success')
      })
      .catch(e => swal('Что-то пошло не так', '' + e, 'error'))
    },
    addStudent() {
      let sameItem = this.item.students.find(student => student.id === this.studentToAdd.id)
      if (!sameItem) {
        let data = {
          id: this.studentToAdd.id,
          class_id: this.$route.params.id
        }
        this.http.post('onAttachStudent', data).then(res => {
          this.item.students.unshift(res.data);
          swal('Успешно!', `Пользователь ${this.studentToAdd.name} добавлен`, 'success')
        })
        
      } else {
        swal('', `Пользователь ${this.studentToAdd.name} уже добавлен`, 'warning')
      }

    },
    saveLessonAttention() {
      let data = {
        id: this.$route.params.id,
        lesson_desc: this.lesson_desc,
      }
      this.http.post('onSaveLessonAttention', data).then(res => {
        swal('Успешно!', 'Информация обновлена!', 'success')
      })
    },
    updateClass(item) {
      this.http.post('onUpdateTeacherClass', item).then(() => {
        swal('Успешно!', 'Класс обновлён!', 'success')
        this.item = item
      })
    },
    init() {
      this.http.post('onGetClass', {
          id: this.$route.params.id
        })
        .then(res => {
          this.item = res.data
          if (this.item.params) {
            this.lesson = this.item.params.current_lesson ? this.item.params.current_lesson : '';
            if (this.item.params.lesson_desc) {
              this.lesson_desc = this.item.params.lesson_desc
            }
          } else {
            this.item.params = {}
          }
        })
        .catch(e => swal('Что-то пошло не так', '' + e, 'error'))

      this.getHomework(this.$route.params.id)
      this.getTemplates(this.$route.params.id)
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.class-title,
.class-text {
  text-align: center;
  margin: 0;
}

.class-title {
  font-size: 16px;
  font-weight: bold;
}

.class-text {
  font-size: 14px;
  color: #999999;
}

.section__menu {
  margin-top: 20px;
}

.reports {
  width: 100%;
  overflow: auto;
}

.class-message {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;  
}

.ckeditor {
  border: 1px solid #e2e2e2;
  border-radius: 8px;
  margin-bottom: 10px;
  width: 100%;
}

.add-student {
  width: 300px;
}

.student-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.homework-list {
  flex-grow: 1;
}


@media (max-width: 640px) {  
  .container {
    flex-direction: column;
    & .info {
      width: 100%;
    }

    & .students {
        margin-left: 0;
        margin-top: 20px;
      }
    }
}
</style>
